import React, { useState } from "react";
import CreateOrderModal from "features/portfolio/CreateOrder/CreateOrderModal";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "@shared/slices/common.slice";
import { openMessage } from "utils/misc";
import { ConsolidatedCoinData, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface SellCoinActionProps {
  coinData: ConsolidatedCoinData;
  isPosition?: boolean;
  trigger: React.JSX.Element | string;
}

const SellCoinAction = ({
  coinData,
  isPosition,
  trigger,
}: SellCoinActionProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const isDarkMode = useSelector(selectIsDarkMode);
  const [createOrderModalOpen, setCreateOrderModalOpen] = useState(false);

  const handleSellClick = () => {
    if (coinData.is_sellable) {
      setCreateOrderModalOpen(true);
    } else {
      openMessage(
        t("assets.exchange_not_support_selling", {
          symbol: coinData.symbol,
        }),
        "warning"
      );
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <div
        onClick={handleSellClick}
        style={coinData.is_sellable ? {} : { opacity: isDarkMode ? 0.3 : 0.4 }}
      >
        {trigger}
      </div>
      <CreateOrderModal
        coinData={coinData}
        closeModal={() => setCreateOrderModalOpen(false)}
        isContract={isPosition}
        isOpen={createOrderModalOpen}
      />
    </div>
  );
};

export default SellCoinAction;
